export default [
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import(/* webpackChunkName: 'PageLogin' */ '../PageLogin'),
    meta: {
      skipRedirectToRoute: true,
      store: ['page/getPageData'],
    },
  },
];
